module.exports = __webpack_public_path__ + "assets/8a570ca8a86b43c396b1c0c8ae6f07bd.mp3";